// extracted by mini-css-extract-plugin
module.exports = {"privacySidebar":"privacySidebar_privacySidebar__y90Rs"};